import { render, staticRenderFns } from "./ViewRequestedDid.vue?vue&type=template&id=067c6ebe&scoped=true&"
import script from "./ViewRequestedDid.vue?vue&type=script&lang=js&"
export * from "./ViewRequestedDid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c6ebe",
  null
  
)

export default component.exports